import axios from "axios";
import {
  ADMIN_FAQS_REQUEST,
  ADMIN_FAQS_SUCCESS,
  ADMIN_FAQS_FAIL,
  FAQ_DETAILS_REQUEST,
  FAQ_DETAILS_SUCCESS,
  FAQ_DETAILS_FAIL,
  NEW_FAQ_REQUEST,
  NEW_FAQ_SUCCESS,
  NEW_FAQ_FAIL,
  NEW_FAQ_RESET,
  FAQ_STATUS_REQUEST,
  FAQ_STATUS_SUCCESS,
  FAQ_STATUS_FAIL,
  FAQ_DELETE_REQUEST,
  FAQ_DELETE_SUCCESS,
  FAQ_DELETE_FAIL,
  FAQ_UPDATE_REQUEST,
  FAQ_UPDATE_SUCCESS,
  FAQ_UPDATE_FAIL,
  CLEAR_ERRORS,
  PUBLIC_FAQS_REQUEST,
  PUBLIC_FAQS_SUCCESS,
  PUBLIC_FAQS_FAIL,
} from "../constants/faqConstants";

const _api_path = process.env.REACT_APP_API_BASE_URL || '/api/v1';

// Get all FAQs for public viewing
export const getFaqs = () => async (dispatch) => {
  try {
    dispatch({ type: PUBLIC_FAQS_REQUEST });

    const { data } = await axios.get(`${_api_path}/faqs`);

    dispatch({
      type: PUBLIC_FAQS_SUCCESS,
      payload: data.data, // Changed from data.faqs to data.data to match backend response structure
    });
  } catch (error) {
    dispatch({
      type: PUBLIC_FAQS_FAIL,
      payload: error.response?.data?.message || "Error fetching FAQs",
    });
  }
};

// Get all FAQs for admin
export const getAdminFaqs = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_FAQS_REQUEST });

    const { data } = await axios.get(`${_api_path}/admin/faqs`);

    dispatch({
      type: ADMIN_FAQS_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_FAQS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Get FAQ details
export const getFaqDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: FAQ_DETAILS_REQUEST });

    const { data } = await axios.get(`${_api_path}/admin/faqs/${id}`);

    dispatch({
      type: FAQ_DETAILS_SUCCESS,
      payload: data.data, // Change from data.faq to data.data to match backend response format
    });
  } catch (error) {
    dispatch({
      type: FAQ_DETAILS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Create new FAQ
export const createFaq = (faqData) => async (dispatch) => {
  try {
    dispatch({ type: NEW_FAQ_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${_api_path}/admin/faqs/add`,
      faqData,
      config
    );

    dispatch({
      type: NEW_FAQ_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: NEW_FAQ_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Update FAQ
export const updateFaq = (id, faqData) => async (dispatch) => {
  try {
    dispatch({ type: FAQ_UPDATE_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${_api_path}/admin/faqs/update/${id}`,
      faqData,
      config
    );

    dispatch({
      type: FAQ_UPDATE_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: FAQ_UPDATE_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Delete FAQ
export const deleteFaq = (id) => async (dispatch) => {
  try {
    dispatch({ type: FAQ_DELETE_REQUEST });

    const { data } = await axios.delete(`${_api_path}/admin/faqs/${id}`);

    dispatch({
      type: FAQ_DELETE_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: FAQ_DELETE_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Toggle FAQ status
export const toggleFaqStatus = (id, status) => async (dispatch) => {
  try {
    dispatch({ type: FAQ_STATUS_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${_api_path}/admin/faqs/status/${id}`,
      { status },
      config
    );

    dispatch({
      type: FAQ_STATUS_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: FAQ_STATUS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Clear Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};
